type Quote = { line: string; scene: string; react: string; tag: string };

const QUOTES: Quote[] = [
  {
    line: "“你搭讪的话术，是淘宝九块九包邮的吗？”",
    scene: "街头对暗恋对象表白",
    react: "当场破防，围观群众笑到扶墙",
    tag: "直球扎心",
  },
  {
    line: "“谢谢你夸我好看，不过我妈说了别跟陌生人走。”",
    scene: "咖啡店搭讪加微信",
    react: "礼貌又致命，男生语塞三秒",
    tag: "礼貌暴击",
  },
  {
    line: "“你的自信是哪家健身房办的卡？”",
    scene: "地铁里被拉住闲聊",
    react: "一句话终结对话，全程高能",
    tag: "灵魂暴击",
  },
  {
    line: "“我挺喜欢你的，就像喜欢前面那家奶茶店，路过会多看两眼。”",
    scene: "酒局当面表白被接招",
    react: "场面一度十分尴尬又好笑",
    tag: "软刀子",
  },
  {
    line: "“先别急着加微信，你上次给我点错的奶茶钱还没转。”",
    scene: "相亲局再次相中熟人",
    react: "当场下不来台，全场起哄",
    tag: "旧账清算",
  },
];

export default function Quotes() {
  return (
    <section id="quotes" className="bg-white py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-5">
          {/* 左侧栏目说明 */}
          <div className="flex flex-col justify-center rounded-3xl bg-gradient-to-br from-orange-500 to-amber-400 p-8 md:p-10 lg:col-span-2">
            <span className="inline-flex w-fit items-center gap-2 rounded-full bg-white/20 px-3 py-1 text-xs font-semibold text-white">
              <i className="ri-message-3-fill" /> 观众留言精选
            </span>
            <h2 className="font-hand mt-5 text-3xl leading-snug text-white md:text-4xl">
              搭讪被怼金句
              <br />
              名场面名句
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-white/85">
              一次翻车不可怕，可怕的是翻车时对方还贡献了一句能让你记十年的金句。每一句都是现场网友评选出的“年度怼人天花板”。
            </p>
            <a
              href="#faq"
              className="mt-7 inline-flex w-fit whitespace-nowrap items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-semibold text-orange-600 transition-colors hover:bg-stone-50"
            >
              我也来投稿金句 <i className="ri-arrow-right-line" />
            </a>
          </div>

          {/* 金句列表 */}
          <div className="flex flex-col gap-4 lg:col-span-3">
            {QUOTES.map((q) => (
              <figure
                key={q.line}
                className="rounded-2xl border border-stone-200 bg-orange-50/40 p-5 transition-colors hover:border-orange-300 hover:bg-orange-50 md:p-6"
              >
                <div className="flex items-start gap-4">
                  <span className="font-hand grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-stone-900 text-2xl text-amber-300">
                    “
                  </span>
                  <div className="min-w-0 flex-1">
                    <blockquote className="text-base font-semibold leading-relaxed text-stone-900 md:text-lg">
                      {q.line}
                    </blockquote>
                    <figcaption className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-stone-500">
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-map-pin-2-line text-orange-400" /> {q.scene}
                      </span>
                      <span className="inline-flex items-center gap-1">
                        <i className="ri-emotion-laugh-line text-orange-400" /> {q.react}
                      </span>
                      <span className="whitespace-nowrap rounded-full bg-teal-100 px-2 py-0.5 font-medium text-teal-700">
                        {q.tag}
                      </span>
                    </figcaption>
                  </div>
                </div>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}